import React, { useEffect, useState } from 'react';
import axiosInstance from '../../api/axios';import { 
  Button, 
  Col, 
  Form, 
  Row, 
  Table, 
  Spinner, 
  Badge,
  Card,
  InputGroup
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Header from '../../layouts/Header';
import { ArrowLeft, Download, FileEarmarkSpreadsheet } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

const RMReorderLevelReport = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();

    const accessToken = localStorage.getItem("authToken");
    const [mainCategoryList, setMainCategoryList] = useState([]);
    const [mainCategoryId, setMainCategoryId] = useState('all');
    const [mainCategoryName, setMainCategoryName] = useState('All Category')
    const [subCategoryList, setSubCategoryList] = useState([]);
    const [subCategoryId, setSubCategoryId] = useState('all');
    const [subCategoryName, setSubCategoryName] = useState('All Sub Category')
    const [rMReportList, setRMReportList] = useState([]);
    const [rmOriginalList, setRMOriginalList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [subBtnLoading, setSubBtnLoading] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
    const [storageLocations, setStorageLocations] = useState([]);
    const [selectedStorageLocation, setSelectedStorageLocation] = useState('all');

    const mainCategoryOptions = [
        { value: 'all', label: 'All Main Categories' },
        ...mainCategoryList.map((rm) => ({
            value: rm._id,
            label: rm.name
        }))
    ];

    const subCategoryOptions = [
        { value: 'all', label: 'All Sub Categories' },
        ...subCategoryList.map((rm) => ({
            value: rm._id,
            label: rm.name
        }))
    ];

    // Storage location options
    const storageLocationOptions = [
        { value: 'all', label: 'All Storage Location' },
        ...storageLocations.map((location) => ({
            value: location._id,
            label: location.name
        }))
    ];
    
    
    // storageLocations?.map(location => ({
    //     value: location?._id,
    //     label: location?.name,
    // }));

    const getStorageLocations = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("storage-location", { headers });

            if (response?.data?.status === true) {
                const activeLocations = response?.data?.data?.storageLocations;
                setStorageLocations(activeLocations);
            }
        } catch (error) {
            // handleApiError(error);
            console.log("Get Storage Location Error :", error);            
        }
    };

    const handleStorageLocationChange = (e) => {
        console.log("selected Storage Location :", e);
        setSelectedStorageLocation(e?.value);
    };

    const handleDownloadExcel = async () => {
        setDownloadBtnLoading(true);
        getReports(true);
    };

    const getReports = async (download) => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            let newUrl = `raw-material/re-order-level-report`;
            if (download) {
                newUrl += `?isDownload=${download}`
            }
            const response = await axiosInstance.get("raw-material/re-order-level-report", { 
                headers,
                responseType: download ? 'blob' : 'json'
            });
            console.log("Response of the reports", response?.data?.data?.rawMaterials);

            if (download) {
                // Create a blob from the response data
                const blob = new Blob([response.data], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });
                
                // Create a link element
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                
                // Set the filename for the download
                const fileName = `${mainCategoryName} of ${subCategoryName} Raw Materials Re-order Level Report.xlsx`;
                link.download = fileName;
                
                // Append the link to the body and trigger the download
                document.body.appendChild(link);
                link.click();
                
                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
        
                toast.success('Excel file downloaded successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light"
                });
            } else {
                setRMReportList(response?.data?.data?.rawMaterials);
                setRMOriginalList(response?.data?.data?.rawMaterials);

                //fetch the main categories from the above response
                const mainCategoryList = response?.data?.data?.rawMaterials.map(material => material.mainCategory);
                const mainCategoryUniqueList = mainCategoryList.filter((material, index, self) =>
                    index === self.findIndex((obj) => obj._id === material._id)
                );
                setMainCategoryList(mainCategoryUniqueList ?? []);

                //fetch the sub categories from the above response
                const subCategoryList = response?.data?.data?.rawMaterials.map(material => material.subCategory);
                const subCategoryUniqueList = subCategoryList.filter((material, index, self) =>
                    index === self.findIndex((obj) => obj._id === material._id)
                );
                console.log("set sub category in use effect");
                setSubCategoryList(subCategoryUniqueList ?? []);
            }

        } catch (error) {
            let errorMessage = '';
            if (error.response?.status === 406) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } finally {
            setLoading(false);
            setDownloadBtnLoading(false);
        }
    };

    const handleMainCategoryChange = (selectedOption) => {
        console.log("Selected Option of main category :", selectedOption);
        
        setMainCategoryId(selectedOption?.value);
        setMainCategoryName(selectedOption?.label);
    };

    const handleSubCategoryChange = (selectedOption) => {
        setSubCategoryId(selectedOption?.value);
        setSubCategoryName(selectedOption?.label);
    };

    const getFilteredStorageLocationRawMaterials = (selectedValue) => {
        if (selectedValue === 'all' || selectedValue === undefined) {
            setRMReportList(prev => [...prev]);
        } else {
            const filteredRawMaterialList = rmOriginalList?.filter(
                material => material?.storageLocation?._id?.toString() === selectedValue?.toString()
            );
            setRMReportList(filteredRawMaterialList ?? []);
        }
    };

    const getFilteredSubCategoryRawMaterials = (selectedValue) => {
        if (selectedValue === 'all' || selectedValue === undefined) {
            setRMReportList(prev => [...prev]);
        } else {
            const filteredRawMaterialList = rmOriginalList?.filter(
                material => material?.subCategory?._id?.toString() === selectedValue?.toString()
            );
            setRMReportList(filteredRawMaterialList ?? []);
        }
    };

    const getFilteredMainCategoryRawMaterials = (selectedCategoryId) => {
        console.log("selectedCategpry id:", selectedCategoryId);
        
        if (selectedCategoryId === 'all' || selectedCategoryId === undefined) {
            const originalRMList = [...rmOriginalList];
            setRMReportList(originalRMList);

            // Update the subcategory list
            const subCategoryList = rmOriginalList?.map(material => material.subCategory);
            const updatedSubCategoryUniqueList = Array.from(
                new Map(subCategoryList.map(item => [item._id, item])).values()
            );
            setSubCategoryList(updatedSubCategoryUniqueList ?? []);
        } else {
            const filteredRawMaterialList = rmOriginalList?.filter(
                material => material?.mainCategory?._id?.toString() === selectedCategoryId?.toString()
            );
            setRMReportList(filteredRawMaterialList ?? []);

            // Update the subcategory list
            const subCategoryList = rmOriginalList?.map(material => material?.subCategory);
            const updatedSubCategoryList = subCategoryList?.filter(
                material => material?.mainCategory?.toString() === selectedCategoryId?.toString()
            );

            const updatedSubCategoryUniqueList = Array.from(
                new Map(updatedSubCategoryList?.map(item => [item._id, item])).values()
            );
            setSubCategoryList(updatedSubCategoryUniqueList);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubBtnLoading(true);
        setClicked(true);
        try {
            getFilteredMainCategoryRawMaterials(mainCategoryId);
            getFilteredSubCategoryRawMaterials(subCategoryId);
            getFilteredStorageLocationRawMaterials(selectedStorageLocation);
        } catch (error) {
            console.log("Error", error);
        } finally {
            setSubBtnLoading(false);
        }
    }

    useEffect(() => {
        getReports();
        getStorageLocations();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div
                className={`main main-app p-3 p-lg-4 ${
                skin === "dark" ? "bg-dark text-light" : "bg-light"
                }`}
            >
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h4 className="mb-0 fw-bold d-inline-block">
                                    <i className="bi bi-box-seam me-2"></i>RAW MATERIAL RE-ORDER LEVEL REPORT
                                </h4>
                            </div>
                            <div>
                                <Button 
                                    variant="outline-secondary" 
                                    size="sm" 
                                    onClick={() => navigate('/reports/all-reports')}
                                    className="me-3 d-flex align-items-center fw-semibold"
                                    style={{ height: '38px' }}
                                >
                                    <ArrowLeft className="me-1" /> Back to Reports
                                </Button>
                            </div>
                        </Card.Header>
                    <hr className='mt-0 mb-0' /> 
                    
                    <Card.Body>
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3 mb-4">
                            <Form onSubmit={handleSubmit}>
                                <Row className="g-3">
                                    <Col md={3}>
                                        <Form.Group controlId="storageLocationSelect">
                                            <Form.Label className="fw-semibold">
                                                Storage Location
                                            </Form.Label>
                                            <Select
                                                isClearable
                                                options={storageLocationOptions}
                                                value={storageLocationOptions?.find(option => option?.value === selectedStorageLocation) || null}
                                                onChange={handleStorageLocationChange}
                                                placeholder="Select Storage Location"
                                                className="border-secondary"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: '#6c757d',
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group controlId="mainCategorySelect">
                                            <Form.Label className="fw-semibold">
                                                RM Main Category
                                            </Form.Label>
                                            <Select
                                                isClearable
                                                isSearchable
                                                placeholder="RM Main Category"
                                                options={mainCategoryOptions}
                                                value={
                                                    mainCategoryOptions?.find(option => option.value === mainCategoryId) || null
                                                }
                                                onChange={handleMainCategoryChange}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                            />
                                        </Form.Group>
                                    </Col>


                                    <Col md={2}>
                                        <Form.Group controlId="subCategorySelect">
                                            <Form.Label className="fw-semibold">
                                                RM Sub Category
                                            </Form.Label>
                                            <Select
                                                isClearable
                                                isSearchable
                                                placeholder="RM Sub Category"
                                                options={subCategoryOptions}
                                                isDisabled={!mainCategoryId}
                                                value={
                                                    subCategoryOptions?.find(option => option.value === subCategoryId) || null
                                                }
                                                onChange={handleSubCategoryChange}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                            disabled={subBtnLoading}
                                        >
                                            {subBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Generate Report"
                                            )}
                                        </Button>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <Button 
                                            variant="outline-success" 
                                            onClick={handleDownloadExcel}
                                            className='w-100 fw-semibold'
                                            disabled={downloadBtnLoading}
                                        >
                                            {downloadBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                <>
                                                    <FileEarmarkSpreadsheet className="me-2" /> Download Excel
                                                </>
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>

                        {/* Results Section */}
                        {!clicked ? (
                            <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                <div className="text-center">
                                    <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                    <h5 className="text-muted mt-3">
                                        Please select categories to view re-order level report
                                    </h5>
                                </div>
                            </div>
                        ) : (
                            <div className="table-responsive border rounded-3">
                                <Table striped bordered hover className="mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th width="50">#</th>
                                            <th>Storage Location</th>
                                            <th>Raw Material</th>
                                            <th>RM Main Category</th>
                                            <th>RM Sub Category</th>
                                            <th width="150" className="text-center">Re-Order Level</th>
                                            <th width="150" className="text-center">Current Stock</th>
                                            <th width="150" className="text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="8" className="text-center py-4">
                                                    <Spinner animation="border" variant="primary" />
                                                    <p className="mt-2 mb-0">Loading re-order level data...</p>
                                                </td>
                                            </tr>
                                        ) : rMReportList?.length > 0 ? (
                                            rMReportList.map((material, index) => (
                                                <tr 
                                                    key={index} 
                                                    style={{ 
                                                        backgroundColor: (material?.inStock === true && material?.isReOrderLevelReached === true) ? "#e6ffe6" : 
                                                                        (material?.inStock === true && material?.isReOrderLevelReached === false) ? "#fff9e6" : "#ffe6e6" 
                                                    }}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{material?.storageLocation ? material?.storageLocation?.name : ""}</td>
                                                    <td className='fw-semibold text-secondary'>{material?.rawMaterial?.name}</td>
                                                    <td>{material?.mainCategory?.name}</td>
                                                    <td>{material?.subCategory?.name}</td>
                                                    <td className='text-center'>
                                                        <span>{material?.rawMaterial?.reOrderLevel}</span> <span>{material?.rawMaterial?.unit}</span>
                                                    </td>
                                                    <td className='text-center'>
                                                        {material?.currentStock?.toFixed(2)} {material?.rawMaterial?.unit}
                                                    </td>
                                                    <td className='text-center'>
                                                        {((material?.rawMaterial?.reOrderLevel === material?.currentStock) && (material?.rawMaterial?.reOrderLevel !== 0)) ? (
                                                            <Badge className='w-75' bg="success">AT RE-ORDER LEVEL</Badge>
                                                        ) : (material?.currentStock === 0) ? (
                                                            <Badge className='w-75' bg="danger">OUT OF STOCK</Badge>
                                                        ) : (
                                                            <Badge className='w-75' bg="warning">LOW STOCK</Badge>
                                                        )}

                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center py-4">
                                                    <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                                                    <p className="mt-2 mb-0 text-muted">
                                                        No raw materials found for the selected criteria
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default RMReorderLevelReport;